import { render } from "./ButtonsDropdown.vue?vue&type=template&id=358f343a&scoped=true"
import script from "./ButtonsDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonsDropdown.vue?vue&type=script&lang=js"

import "./ButtonsDropdown.vue?vue&type=style&index=0&id=358f343a&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358f343a"]])

export default __exports__